
<template>
    <div class="center">
      <vs-dialog v-model="active" prevent-close>
        <template #header>
          <h4 class="not-margin">
              Editar archivo externo
          </h4>
        </template>
        <div class="con-form mb-3">
            <vs-row class="mt-4">
                <vs-col sm="12" lg="6">
                    <form autocomplete="off">
                        <label for="institucion" class="labelInput">
                            Institución <i class="fas fa-shield-alt"></i>
                        </label>
                        <vs-select filter :loading="loadingInstituto" class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" :disabled="!instituciones.length" autocomplete="off">
                            <template #message-danger v-if="errorFields.includes('institucion')">
                                Requerido
                            </template>
                            <template v-if="instituciones.length" autocomplete="off">
                                <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </template>
                            <template v-else>
                                <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                </vs-option>
                            </template>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="6">
                    <form autocomplete="off">
                        <label for="cicloEscolar" class="labelInput">
                            Ciclo Escolar
                        </label>
                        <vs-select :loading="loadingCiclo" class="aqui pt-0" id="cicloEscolar" placeholder="Seleccionar Ciclo Escolar" :key="cicloId" v-model="cicloEscolar"  :disabled="!ciclosEscolares.length">
                            <template #message-danger v-if="errorFields.includes('cicloEscolar')">
                                Requerido
                            </template>
                            <template v-if="ciclosEscolares.length" autocomplete="off">
                                <vs-option v-for="option in ciclosEscolares" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </template>
                            <template v-else>
                                <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                </vs-option>
                            </template>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="6">
                    <label for="institucion" class="labelInput">
                        Nivel académico
                    </label>
                    <vs-select filter multiple collapse-chips class="aqui pt-0" id="nivel" placeholder="Seleccionar nivel académico" :key="nivelId" v-model="nivel" :disabled="!niveles.length" autocomplete="off">
                        <template #message-danger v-if="errorFields.includes('nivel')">
                            Requerido
                        </template>
                        <template v-if="niveles.length" autocomplete="off">
                            <vs-option v-for="option in niveles" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>
                </vs-col>
                <vs-col sm="12" lg="6">
                    <form autocomplete="off">
                        <label for="clave" class="labelInput ">
                            Clave
                        </label>
                        <vs-input class="pt-0" id="clave" v-model="clave" placeholder="Clave">
                            <template #message-danger v-if="errorFields.includes('clave')">
                                Requerido
                            </template>
                        </vs-input>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="6">
                    <form autocomplete="off">
                        <label for="nombre" class="labelInput">
                            Nombre
                        </label>
                        <vs-input class="pt-0" id="nombre" v-model="nombre" placeholder="Nombre">
                            <template #message-danger v-if="errorFields.includes('nombre')">
                                Requerido
                            </template>
                        </vs-input>
                    </form>
                </vs-col>
                <vs-col vs-justify="center" vs-align="center" w="12" class="my-4">
                    <md-field class="mb-0">
                        <label class="labelInput">Descripción </label>
                        <md-textarea
                            v-model="descripcion"
                            id="descripcion"
                            name="descripcion">
                        </md-textarea>
                    </md-field>
                    <p v-if="errorFields.includes('descripcion')" class="vs-select__message vs-select__message--danger">Requerido</p>
                </vs-col>
                <vs-col sm="12" lg="6">
                    <label>¿Es visible para el padre de familia?</label>
                    <vs-select  placeholder="Seleccione una opción" v-model="visible" class="pl-0">
                        <vs-option label="Si" value="si">
                            Si
                        </vs-option>
                        <vs-option label="No" value="no">
                            No
                        </vs-option>
                        <template #message-danger v-if="errorFields.includes('visible')">
                            Requerido
                        </template>
                    </vs-select>
                </vs-col>
                <!-- <vs-col sm="12" lg="6">
                    <label>¿Requiere entrega por parte del alumno?</label>
                    <vs-select placeholder="Seleccione una opción" v-model="entrega" class="pl-0">
                        <vs-option label="Si" value="si">
                            Si
                        </vs-option>
                        <vs-option label="No" value="no">
                            No
                        </vs-option>
                        <template #message-danger v-if="errorFields.includes('entrega')">
                            Requerido
                        </template>
                    </vs-select>
                </vs-col>
                <vs-col v-if="entrega == 'no'" sm="12" lg="12" class="mt-2">
                    <label>¿Diseñar documento?</label>
                    <vs-select @input="getDisabled()" placeholder="Seleccione una opción" v-model="diseno" class="pl-0 mr-0">
                        <vs-option label="Si" value="si">
                            Si
                        </vs-option>
                        <vs-option label="No" value="no">
                            No
                        </vs-option>
                        <template #message-danger v-if="errorFields.includes('diseno')">
                            Requerido
                        </template>
                    </vs-select>
                </vs-col> -->
            </vs-row>
            <!-- <vs-row v-if="diseno == 'si' && entrega == 'no'">
                <vs-col sm="12" lg="12">
                    <vue-editor  @input="getDisabled()" v-model="personalizado">
                    </vue-editor>
                    <p v-if="errorFields.includes('personalizado')" class="vs-select__message vs-select__message--danger">Requerido</p>
                </vs-col>
                <vs-col class="mt-4 p-0" sm="12" lg="12">
                    <div id="accordion">
                        <div class="card">
                            <div class="card-header" id="headingOne">
                            <h5 class="mb-0">
                                <button class="btn btn-link" data-toggle="collapse" style="color: gray;" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    <i class="fas fa-sort-down mr-2"></i> Campos disponibles para formato
                                </button>
                            </h5>
                            </div>
                            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                            <div class="card-body">
                                <p>Recuerda copiar la variable tal cual se describe. Ejemplo : <span style="color: red;">{variable}</span></p>
                                <vs-table>
                                    <template #thead>
                                    <vs-tr>
                                        <vs-th>
                                            Campo
                                        </vs-th>
                                        <vs-th>
                                            Variable
                                        </vs-th>
                                        <vs-th>
                                            Copiar
                                        </vs-th>
                                    </vs-tr>
                                    </template>
                                    <template #tbody>
                                    <vs-tr
                                        :key="i"
                                        v-for="(tr, i) in variables"
                                        :data="tr"
                                        style="border-bottom:1px solid #DFDFDF"
                                    >
                                        <vs-td>
                                            {{ tr.title }}
                                        </vs-td>
                                        <vs-td>
                                            {{ tr.clave }}
                                        </vs-td>
                                        <vs-td>
                                            <vs-button
                                                flat 
                                                v-clipboard="'{' + tr.clave + '}'"
                                            >
                                                <i class="far fa-copy mr-2"></i> Copiar
                                            </vs-button>
                                        </vs-td>
                                    </vs-tr>
                                    </template>
                                </vs-table>
                            </div>
                            </div>
                        </div>
                    </div>
                </vs-col>
                <vs-col sm="12" lg="6" class="mt-4">
                    <form autocomplete="off">
                        <label for="institucion" class="labelInput">
                            Incluir Firma
                        </label>
                        <vs-select  @input="getDisabled()" filter :loading="loadingInstituto" class="aqui pt-0" id="institucion" placeholder="Seleccionar firma" :key="firmaId" v-model="firma">
                            <template>
                                <vs-option v-for="option in firmas" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </template>
                            <template #message-danger v-if="errorFields.includes('firma')">
                                Requerido
                            </template>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="6" class="mt-4">
                    <form autocomplete="off">
                        <label for="institucion" class="labelInput">
                            Membrete
                        </label>
                        <vs-select  @input="getDisabled()" filter class="aqui pt-0" id="institucion" placeholder="Seleccionar membrete" :key="membreteId" v-model="membrete">
                            <template>
                                <vs-option v-for="option in membretes" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </template>
                            <template #message-danger v-if="errorFields.includes('membrete')">
                                Requerido
                            </template>
                        </vs-select>
                    </form>
                </vs-col>
            </vs-row> -->
            <vs-row>
                <vs-col>
                    <p>Seleccione un archivo, no debe ser mayor a 5 MB</p>
                    <div class="d-flex">
                        <div class="mr-2 archivos">
                            <label :style="institucion != '' ? 'background: rgb(26, 92, 255); width:100; border-radius: 5px; cursor:pointer;padding: 5px 15px; color: white; margin-bottom: 0' : 'background: rgb(169, 204, 227 ); width:100; border-radius: 5px; cursor:pointer;padding: 5px 15px; color: white; margin-bottom: 0'">Archivos
                                <!-- <input type="file" id="files" ref="files"/> -->
                                
						        <input :disabled="institucion == ''" type="file"  ref="files" name="documento" id="me_documento" aria-describeby="me_documento_ayuda" accept="application/pdf"  v-on:change="handleFilesUpload()" @input="postGuardarDocumento()">
                            </label>
                        </div>
                        <div v-if="(archivoPath != '' || archivoPath != null) && !files[0] " class="file-listing" style="background: #F4F4F4; padding: 8px; border-radius: 5px">{{ archivoPath }} <i v-on:click="archivoPath = '', getDisabled()" class="fas fa-times-circle"></i></div>
                        <div v-for="(file, key) in files" :key="key" class="d-flex mr-1 ml-1">
                            <div class="file-listing" style="background: #F4F4F4; padding: 8px; border-radius: 5px">{{ file.name }} <i v-on:click="files = []" class="fas fa-times-circle"></i></div>
                        </div>
                    </div>
                    <p style="color: #C0392B" v-if="sobrepeso"><strong>El archivo es mayor a 5MB</strong></p>
                    <p v-if="errorFields.includes('archivo')"  class="vs-select__message vs-select__message--danger">Requerido</p>
                </vs-col>
            </vs-row>
        </div>

        <template #footer>
            <vs-row>
                <vs-col sm="12" lg="6">
                    <vs-button style="width: 40%;" block danger class="color-red" @click="active = false">
                    Cancelar
                    </vs-button>
                </vs-col>
                <vs-col sm="12" lg="6">
                    <vs-button style="width: 40%;" class="ml-auto" block success @click="postGuardarDocumentoInformacion(row.path)">
                    Aceptar
                    </vs-button>
                </vs-col>
            </vs-row>
        </template>
      </vs-dialog>
    </div>
</template>
<script>
import catalogos from '../../../../../api/requests/catalogos'
import configuracion from '../../../../../api/requests/configuracion'
import { VueEditor } from "vue2-editor";
import VueClipboards from 'vue-clipboards'
Vue.use(VueClipboards)
export default {
    props:[
        'value',
        'instituciones',
        'row'
    ],
    data:()=> ({
        active: false,
        institucion:'',
        institucionId: (new Date()).getTime(),
        loadingInstituto: false,
        cicloEscolar: '',
        ciclosEscolares: [],
        cicloId: (new Date()).getTime(),
        loadingCiclo: false,
        nivel: [],
        nivelId: (new Date()).getTime(),
        niveles: [],
        loadingNivel: false,
        clave: '',
        nombre: '',
        descripcion: '',
        visible: '',
        entrega: '',
        personalizado: '',
        diseno:'',
        customToolbar: [["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }], ["image", "code-block"]],
        variables: [
             {
                "clave": "matricula",
                "title": "Matrícula"
            },
            {
                "clave":"expediente",
                "title": "Expediente"
            },
            {
                "clave": "imagen_alumno",
                "title": "Imagen del alumno"
            },
            {
                "clave": "nombre",
                "title": "Nombre(s) del alumno"
            },
            {
                "clave": "ap_paterno",
                "title": "Apellido Paterno"
            },
            {
                "clave": "ap_materno",
                "title": "Apellido Materno"
            },
            {
                "clave": "fecha_nacimiento",
                "title": "Fecha de nacimiento"
            },
            {
                "clave": "edad",
                "title": "Edad"
            },
            {
                "clave": "lugar_nacimiento",
                "title": "Lugar de Nacimiento"
            },
            {
                "clave": "nacionalidad",
                "title": "Nacionalidad"
            },
            {
                "clave": "curp",
                "title": "CURP"
            },
            {
                "clave": "sexo",
                "title": "Sexo"
            },
            {
                "clave": "calle",
                "title": "Calle"
            },
            {
                "clave": "delegacion",
                "title": "Municipio / Delegación"
            },
            {
                "clave": "colonia",
                "title": "Colonia"
            },
            {
                "clave": "cp",
                "title": "Código Postal"
            },
            {
                "clave": "ciudad",
                "title": "Ciudad"
            },
            {
                "clave": "telefono",
                "title": "Teléfono"
            },
            {
                "clave": "estado",
                "title": "Estado"
            },
            {
                "clave": "email",
                "title": "Correo electrónico"
            },
            {
                "clave": "vive_con",
                "title": "Vive con (parentesco)"
            },
            {
                "clave": "padre",
                "title": "Nombre Padre"
            },
            {
                "clave": "ocupacion_padre",
                "title": "Ocupación Padre"
            },
            {
                "clave": "padre_tel",
                "title": "Tel Casa Padre"
            },
            {
                "clave": "padre_celular",
                "title": "Tel Celular Padre"
            },
            {
                "clave": "padre_trabajo",
                "title": "Tel Trabajo Padre"
            },
            {
                "clave": "padre_extension",
                "title": "Ext Padre"
            },
            {
                "clave": "padre_email",
                "title": "Correo Padre"
            },
            {
                "clave": "madre",
                "title": "Nombre Madre"
            },
            {
                "clave": "ocupacion_madre",
                "title": "Ocupación Madre"
            },
            {
                "clave": "madre_tel",
                "title": "Teléfono Madre"
            },
            {
                "clave": "madre_celular",
                "title": "Tel Celular Madre"
            },
            {
                "clave": "madre_trabajo",
                "title": "Tel Trabajo Madre"
            },
            {
                "clave": "madre_extension",
                "title": "Ext Madre"
            },
            {
                "clave": "madre_email",
                "title": "Correo Madre"
            },
            {
                "clave": "nombre_tutor",
                "title": "Nombre del Tutor"
            },
            {
                "clave": "tutor_tel",
                "title": "Teléfono Tutor"
            },
            {
                "clave": "tutor_celular",
                "title": "Tel Celular Tutor"
            },
            {
                "clave": "tutor_trabajo",
                "title": "Tel Trabajo Tutor"
            },
            {
                "clave": "tutor_extension",
                "title": "Ext Tutor"
            },
            {
                "clave": "tutor_email",
                "title": "Correo Tutor"
            },	
            {
                "clave": "rfc",
                "title": "RFC"
            },
            {
                "clave": "razon_social",
                "title": "Razón social"
            },
            {
                "clave": "domicilio_fiscal",
                "title": "Domicilio Fiscal"
            },
            {
                "clave": "fecha_actual",
                "title": "Fecha Actual"
            },
            {
                "clave": "grupo",
                "title": "Grupo"
            },
            {
                "clave": "grado_actual",
                "title": "Grado actual"
            },
            {
                "clave": "grado_siguiente",
                "title": "Grado siguiente"
            },
            {
                "clave": "programa",
                "title": "Programa"
            },
            {
                "clave": "firma_director",
                "title": "Firma director"
            }
        ],
        firma: '',
        firmas: [
            {
                "id": '4', 
                "text": "Hno. Alfonso de Jesús Fernández Peña"
            },
            {
                "id": '3', 
                "text": "María Concepción Ruiz Rodríguez"
            },
            {
                "id": '1', 
                "text": "Ninguna"
            }
        ],
        firmaId: (new Date()).getTime(),
        membrete: '',
        membretes: [
            {
                'id': '4',
                'text': 'Instituto Potosino Marista Sec-Prepa'
            },
            {
                'id': '3',
                'text': 'Instituto Potosino Marista Primaria'
            },
            {
                'id': '1',
                'text': 'Ninguno'
            }
        ],
        membreteId: (new Date()).getTime(),
        errorFields: [],
        files: [],
        sobrepeso: false,
        archivoPath: '',
        pathArchivo: '',
        cargaDocumentoOestilo: true
    }),
    components: {
        VueEditor
    },
    methods:{
        
        async getCicloEscolar() {
            if(this.institucion){
                this.loadingCiclo = true
                const { data: response } = await configuracion.getCiclosEscolares(this.institucion)
                this.ciclosEscolares = response
                this.cicloId = (new Date()).getTime()
                this.loadingCiclo = false
            }
        },
        async getNivel(){
            if(this.institucion){
                try { 
                    const response = await catalogos.getNivelesAcademicos(this.institucion)
                    this.niveles = response.data
                    this.nivelId = (new Date()).getTime()
                }catch{
                    
                }
            }
        },
        handleFilesUpload(){
            this.archivoPath = ''
            this.files = this.$refs.files.files
            console.log(this.files)
            const documento = this.files[0].size
            if(documento > 5000000){
                this.sobrepeso = true
            }else{
                this.sobrepeso = false
            }
        },
        getDisabled(){
            if(this.diseno == 'no'){
                if(!this.archivoPath && !this.pathArchivo){
                    this.cargaDocumentoOestilo = true
                }else{
                    this.cargaDocumentoOestilo = false
                }
            }
            if(this.diseno == 'si'){
                if(!this.membrete && !this.firma && !this.personalizado){
                    this.cargaDocumentoOestilo = true
                }else if(this.membrete && this.firma && this.personalizado){
                    this.cargaDocumentoOestilo = false
                }
            }
        },
        getInfo(){ 
            this.institucion = this.row.institucion_id != '' ?  this.row.institucion_id : ''
            if(this.row.ciclo_escolar_id && this.row.ciclo_escolar_id != ''){
                this.cicloEscolar =this.row.ciclo_escolar_id
            }else{
                this.cicloEscolar = ''
            }
            this.nivel =  JSON.parse(this.row.niveles_academicos_ids) != '' ?  this.row.niveles_academicos_ids : ''
            this.clave = this.row.clave != '' ?  this.row.clave : ''
            this.nombre = this.row.nombre != '' ?  this.row.nombre : ''
            this.descripcion = this.row.descripcion != '' ?  this.row.descripcion : ''
            this.visible = this.row.es_visible != '' ?  this.row.es_visible : ''
            this.entrega = this.row.requiere_respuesta != '' ?  this.row.requiere_respuesta : ''
            this.personalizado = this.row.formato == null ? '' : this.row.formato 
            this.diseno =this.row.con_formato != '' ?  this.row.con_formato : ''
            this.firma = this.row.firma == null ?  '' :  this.row.firma
            this.membrete = this.row.membrete == null ? '' : this.row.membrete
            this.sobrepeso = false
            this.archivoPath = this.row.path
            console.log()
            this.getDisabled()
        },
        sanityForm () {
            this.errorFields = []
            if (!this.institucion) {
                this.errorFields.push('institucion')
            }
            if (!this.nivel) {
                this.errorFields.push('nivel')
            }
            if (!this.clave) {
                this.errorFields.push('clave')
            }
            if (!this.nombre) {
                this.errorFields.push('nombre')
            }
            if (!this.descripcion) {
                this.errorFields.push('descripcion')
            }
            if (!this.visible) {
                this.errorFields.push('visible')
            }
            if (!this.entrega) {
                this.errorFields.push('entrega')
            }
            
            if (!this.cicloEscolar) {
                this.errorFields.push('cicloEscolar')
            }
            // if (!this.diseno) {
            //     this.errorFields.push('diseno')
            // }
            
            // if (this.entrega == 'no') {
                
            //     if (!this.diseno) {
            //         this.errorFields.push('diseno')
            //     }
            //     if(this.diseno == 'si'){
            //         if (!this.personalizado) {
            //             this.errorFields.push('personalizado')
            //         }
            //         if (!this.firma) {
            //             this.errorFields.push('firma')
            //         }
            //         if (!this.membrete) {
            //             this.errorFields.push('membrete')
            //         }
            //     }else{
                    if (!this.archivoPath && this.pathArchivo) {
                        this.errorFields.push('archivo')
                    }
            //     }
            // }

            if (!this.errorFields.length){
                return true
            } else {
                return null
            }
        },
        async postGuardarDocumento(){
            if(this.institucion != ''){
                try {
                    this.files = []
                    const selectedFile = this.$refs.files.files[0]
                    const formData = new FormData()
                    formData.append('institucion_id', this.institucion)
                    formData.append('ciclo_escolar_id', this.cicloEscolar)
                    formData.append('documento', selectedFile)
                    const response = await configuracion.postGuardarDocumento(formData)
                    this.pathArchivo = response.data.path
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        title: 'Operación éxitosa.',
                        text: 'Se cargó con éxtio el documento.'
                    })
                    this.cargaDocumentoOestilo = false
                }catch(error){
                    console.log(error)
                    this.cargaDocumentoOestilo = true
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Error al cargar el documento.',
                        text: 'Favor de contactar al administrador.'
                    })
                }
            }
        },
        async postGuardar(path){
            const seguir = this.sanityForm()
            if(seguir){
                if(this.diseno == 'no' && (path == '' || path == null)){
                    this.postGuardarDocumento()
                }else{
                    this.postGuardarDocumentoInformacion()
                }
            }
        },
        async postGuardarDocumentoInformacion(path){
                const loading = this.$vs.loading()
                try {
                    const params = {
                        institucion_id: this.institucion,
                        ciclo_escolar_id: this.cicloEscolar,
                        niveles_academicos_ids: this.nivel,
                        clave: this.clave,
                        nombre: this.nombre,
                        descripcion: this.descripcion,
                        es_visible: this.visible,
                        requiere_respuesta: this.entrega,
                        con_formato: this.diseno,
                        formato: this.personalizado,
                        firma: this.firma,
                        membrete: this.membrete,
                        documento_id: this.row.id,
                        path: path != '' ? path : this.pathArchivo
                    }
                    
                    if(path != ''){
                        console.log("aqui entro path")
                        params.path = this.pathArchivo
                    }
                    if(this.archivoPath != ''){
                        console.log("aqui entro archivo")
                        params.path = this.archivoPath
                    }
                    
                    if(this.nivel[0] == ''){
                        const eliminar = this.nivel.shift()
                        params.niveles_academicos_ids = this.nivel
                    }else{
                        params.niveles_academicos_ids = this.nivel
                    }
                    // if(this.diseno == 'si'){
                    //     params.path = null
                    //     params.formato = this.personalizado
                    //     params.firma = this.firma
                    //     params.membrete = this.membrete

                    // }else if(this.diseno == 'no'){
                    //     params.formato = ''
                    //     params.firma = ''
                    //     params.membrete = ''
                    //     if(this.pathArchivo != ''){
                    //         console.log("aqui entro path")
                    //         params.path = this.pathArchivo
                    //     }else{
                    //         console.log("aqui entro archivo")
                    //         params.path = this.archivoPath
                    //     }
                    // }
                    const payload = Object.assign(params)
                    console.log(payload)
                    const response = await configuracion.postActualizarDocumentoInformacion(payload)
                    this.$emit('refreshTable')
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        title: 'Operación éxitosa.',
                        text: 'Se ha creado con éxito el registro.'
                    })
                    loading.close()
                    this.files = []
                    this.active = false
                }catch(error){
                    loading.close()
                    this.active = false
                    console.log(error)
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Algo salió mal.',
                        text: 'Póngase en contacto con el administrador.'
                    })
                }}
    },
    watch: {
        value (val) {
            this.active = val
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
        row(){
            this.getInfo()
        },
        institucion(){
            this.getCicloEscolar()
            this.getNivel()
        }
    }
}
</script>

<style scoped>

    .archivos input[type="file"]{
        position: absolute;
        top: 0px !important;
        visibility: hidden;
    }
</style>